module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAA10lEQVR4AeyWCQrCMBBFjdfSu2jRa4l6F+9lPxRKKDPQzkJS+kumpMtMHi+B5Hzq/CKgd4JoMMXg33F5gZb5nOKlka3PmsE7ClkDqXFNBCylfIsx4tCmSiLg9KmPOwG980CDNOg14M3f5xrEWeHdMB61dc2gdZuLyLuuAaz/adrXDH5A1Sp+GHtuIiAOCkPDeM106IiAeN9NOwpgnnAa9LqlwWMaxEHhlhAXi01tDWZsc89IQEutlBzNYMpglqIiIA4KGW0IA7QUysoRDWYNZqlLQIu1OmcEAAD//2OVMfQAAAAGSURBVAMAKJlDYLfAEl4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bar-chart-horizontal-line.png
// module id = 9bkQ
// module chunks = 9